import {NgModule} from '@angular/core';
import {Config, GlobalMessageConfig, provideConfig} from '@spartacus/core';
import {defaultCmsContentProviders, mediaConfig} from '@spartacus/storefront';
import {CommerceConfig} from '../config/CommerceConfig';
import {LayoutConfig} from '../config/LayoutConfig';
import {RoutingConfig} from '../config/RoutingConfig';
import {translationChunksConfig, translationsEn} from '@spartacus/assets';
import {APP_CONFIG} from '@app/config/AppConfig';

@NgModule({
  providers: [
    provideConfig(LayoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      i18n: {
        resources: {en: translationsEn},
        chunks: translationChunksConfig,
      },
    }),
    provideConfig(CommerceConfig),
    provideConfig(RoutingConfig),
    provideConfig(GlobalMessageConfig as Config),
    provideConfig(APP_CONFIG as Config),
  ],
})
export class SpartacusConfigurationModule {}
